import type { InstrumentRef } from "@screener/protocol";
import { marketLabel } from "@/lib/labels";
import { ExchangeLogo } from "./exchange-logo";

/**
 * Биржа и рынок в ячейке табличных видов §9 (1.51, §64 п. 1): знак биржи
 * (`ExchangeLogo`, с текстовой альтернативой) и рынок словом рядом. Одна
 * разметка на строку плотности и строку группы ситуаций — две копии разошлись
 * бы при первой правке.
 */
export function VenueMark({
  instrument,
}: {
  instrument: Pick<InstrumentRef, "exchange" | "market">;
}) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <ExchangeLogo exchange={instrument.exchange} />
      <span className="text-[11px] tracking-wider uppercase">{marketLabel(instrument.market)}</span>
    </span>
  );
}
